import { useState, useEffect } from "react";
import styles from "../styles/GitHubPage.module.css";
import GitHubCalendar from "react-github-calendar";

// if you had Github followers, you could use this to display them

export default function GithubPage() {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  
  // Generate years from 2023 to current year, reversed (most recent first)
  for (let year = currentYear; year >= 2023; year--) {
    years.push(year);
  }

  // State to track which years should be rendered
  const [visibleYears, setVisibleYears] = useState<number[]>([]);

  useEffect(() => {
    // Load calendars sequentially with 1 second delay between each
    const loadCalendars = async () => {
      for (let i = 0; i < years.length; i++) {
        await new Promise(resolve => setTimeout(resolve, i * 1000));
        setVisibleYears(prev => [...prev, years[i]]);
      }
    };
    loadCalendars();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={styles.user}>
        <img
          src={"Logo.gif"}
          alt={`Wayne Rockett's avatar`}
          className={styles.avatar}
        />
        <div className={styles.username}>
          <a 
            href="https://github.com/WayneRockett" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            Wayne Rockett
          </a>
        </div>
        <div>3 Organisations</div>
        <div>14 Repos</div>
      </div>
      <div className={styles.container}>
        {/* {repos.map((repo) => (
          <RepoCard key={repo.id} repo={repo} />
        ))} */}
      </div>
      <div className={styles.contributions}>
        <h3>
          GitHub Contributions{' '}
          <a 
            href="https://github.com/WayneRockett" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ fontSize: '0.8em', textDecoration: 'none' }}
          >
            @WayneRockett
          </a>
        </h3>
        {visibleYears.map((year) => (
          <div key={year} className={styles.calendar} style={{ marginBottom: '2rem' }}>
            <h4>{year}</h4>
            <GitHubCalendar username="WayneRockett" year={year} />
          </div>
        ))}
      </div>
    </>
  );
}
